import { Pipe, PipeTransform } from '@angular/core'
import { Quantity } from '@elderbyte/ngx-starter'
import { MaterialComponent } from '../../domain/orders/work-items/bom/material-component'

@Pipe({
  name: 'productSalesQuantity',
})
export class ProductSalesQuantityPipe implements PipeTransform {
  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public transform(component: MaterialComponent, ...args: unknown[]): Quantity | null {
    return MaterialComponent.salesQuantity(component)
  }
}
